export const setUserId = (id: number) => {
  localStorage.setItem("userId", id.toString());
};

export const getUserId = () => {
  const storedUserId = localStorage.getItem("userId");
  const parsedUserId = parseInt(storedUserId || "NaN"); // If 'userId' is not found, use 'NaN'
  return isNaN(parsedUserId) ? null : parsedUserId;
};

export const setUserName = (name: string | null) => {
  if (name == null || name === "") {
    localStorage.removeItem("userName");
    return;
  }
  localStorage.setItem("userName", name);
};

export const getUserName = () => {
  const storedUserName = localStorage.getItem("userName");
  if (!storedUserName || storedUserName === "null") {
    return null;
  }
  return storedUserName;
};
export const setFirstName = (name: string) => {
  localStorage.setItem("firstName", name);
};

export const getFirstName = () => {
  const storedUserName = localStorage.getItem("firstName");
  return storedUserName;
};
export const setLastName = (name: string) => {
  localStorage.setItem("lastName", name);
};

export const getLastName = () => {
  const storedUserName = localStorage.getItem("lastName");
  return storedUserName;
};

export const setProfileImage = (name: string | null) => {
  // Bug 79975: removing the photo has to clear the key, not write an empty/"null" string, or
  // getProfileImage resurrects the removed image on the next page load.
  if (!name) {
    localStorage.removeItem("profileImage");
    return;
  }
  localStorage.setItem("profileImage", name);
};

export const getProfileImage = () => {
  const storedProfileImage = localStorage.getItem("profileImage");
  if (!storedProfileImage || storedProfileImage === "null") {
    return null;
  }
  return storedProfileImage;
};
